import styled from 'styled-components';

import { Radio } from 'components/primitives/radio';

import { AnketaInputMask, AnketaDaData, AnketaFormHeader } from '../../../MainAnketa.styles';
import { FormGridRowBase } from '../../AnketaForm.styles';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas:
    '. head head head head . . .'
    '. sn sn date date code code .'
    '. iss iss iss iss iss iss .'
    '. bp bp bp bp bd bd .'
    '. ge ge ge ge ge ge .'
    '. hide hide . . . . .'
    '. phm phm phm phm phm phm . ';
`;

export const FormHeader = styled(AnketaFormHeader)`
  grid-area: head;
  grid-template-areas: '. . . . . . . .';
  margin-top: 8px;
`;

export const FormSubheaderPassportMVD = styled.div`
  grid-area: phm;
  text-align: start;

  > svg {
    margin-left: 0px;
    width: 12px;
    height: 12px;
    fill: var(--color-red-2);
  }

  > span {
    margin-left: 5px;
    color: var(--color-red-2);
  }
`;

export const SeriaNumber = styled(AnketaInputMask)`
  grid-area: sn;
`;

export const IssueDate = styled(AnketaInputMask)`
  grid-area: date;
`;

export const IssuerCode = styled(AnketaDaData)`
  grid-area: code;
`;

export const Issuer = styled(AnketaDaData)`
  grid-area: iss;
`;

export const BirthdayPlace = styled(AnketaInputMask)`
  grid-area: bp;
`;

export const BirthdayDate = styled(AnketaInputMask)`
  grid-area: bd;
`;

export const Gender = styled(Radio)`
  grid-area: ge;
`;
